import {useCallback} from 'react';
import {useControls, useTransformComponent} from 'react-zoom-pan-pinch';
import {Button, Tooltip} from '../../../components';
import {ZoomIn, ZoomOut} from '../../../icons';

interface ZoomButtonsProps {
  boundingId: string;
  minScale: number;
  maxScale: number;
  onUserTransformStart?: () => void;
}

const ZOOM_STEP = 0.5;

export const ZoomButtons = ({
  boundingId,
  minScale,
  maxScale,
  onUserTransformStart,
}: ZoomButtonsProps) => {
  const controls = useControls();
  const scale = useTransformComponent((state) => state.state.scale);

  const onClickZoomIn = useCallback(() => {
    onUserTransformStart?.();
    controls.zoomToElement(
      `rect-bounding-${boundingId}`,
      Math.min(scale + ZOOM_STEP, maxScale),
      200,
    );
  }, [boundingId, controls, maxScale, onUserTransformStart, scale]);

  const onClickZoomOut = useCallback(() => {
    onUserTransformStart?.();
    controls.zoomToElement(
      `rect-bounding-${boundingId}`,
      Math.max(scale - ZOOM_STEP, minScale),
      200,
    );
  }, [boundingId, controls, minScale, onUserTransformStart, scale]);

  return (
    <div className="absolute bottom-4 left-4 z-[90] transition-all">
      <div className="flex select-none items-center gap-1">
        <Tooltip message="Уменьшить">
          <Button
            variant="outline"
            shape="square"
            disabled={scale <= minScale}
            onClick={onClickZoomOut}
          >
            <ZoomOut className="size-6" />
          </Button>
        </Tooltip>
        <Tooltip message="Увеличить">
          <Button
            variant="outline"
            shape="square"
            disabled={scale >= maxScale}
            onClick={onClickZoomIn}
          >
            <ZoomIn className="size-6" />
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
